import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from '../locales/en.json';
import commonFa from '../locales/fa.json';
import commonDe from '../locales/de.json';

export const commonResources = {
  en: commonEn,
  fa: commonFa,
  de: commonDe,
};

export function initializeI18n(appResources: any) {
  // Merge common and app resources
  const resources = {
    en: { 
      translation: {
        ...commonResources.en,
        ...appResources.en.translation,
      }
    },
    fa: { 
      translation: {
        ...commonResources.fa,
        ...appResources.fa.translation,
      }
    },
    de: { 
      translation: {
        ...commonResources.de,
        ...appResources.de.translation,
      }
    },
  };

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
      },
    });

  // Set initial document direction based on current language
  const setDocumentDirection = (lng: string) => {
    document.documentElement.dir = lng === 'fa' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  };

  // Set direction on initialization
  setDocumentDirection(i18n.language);

  // Listen for language changes and update direction
  i18n.on('languageChanged', setDocumentDirection);

  return i18n;
}

export default i18n;
